import {
  ADD_VIDEO,
  IVideosActions,
  IVideosState,
  SET_VIDEO_CAPTIONS,
  SET_VIDEO_CAPTIONS_EMPTY
} from './types';
import { Reducer } from 'redux';

const initialState: IVideosState = {
  captions: {},
  captionsEmpty: false,
};

export const videoReducer: Reducer<IVideosState, IVideosActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ADD_VIDEO:
      return {
        ...state,
        ...action.video
      }
    case SET_VIDEO_CAPTIONS:
      return {...state, captions: {
        ...state.captions, [action.code]: [...action.captions]
      }}
    case SET_VIDEO_CAPTIONS_EMPTY:
      return {...state, ...{captionsEmpty: action.captionsEmpty}}
    default:
      return state;
  }
};
